<template>
  <div>
    <y-dialog
      title="新建积分屏蔽规则"
      :visible.sync="visible"
      width="1120px"
      :before-close="handleDialogClose"
      append-to-body
      sureText="保存"
      @comfirm="handleDialogConfirm()"
      @close="handleDialogClose()"
    >
      <!-- 规则名称 -->
      <div style="margin-bottom: 30px;font-size:12px">
        <span style="color: red;margin-right: 5px;">*</span>规则名称：<el-input v-model="ruleName" style="width: 290px"
          maxlength="20" show-word-limit></el-input>
      </div>
      <!-- 规则设置 -->
      <div class="main">
        <!-- 左侧可选属性 -->
        <div class="left_box">
          <div class="label_box" v-for="label in options" :key="label.name" :name="label.name">
            <!-- 标题 -->
            <div class="label_title">{{ label.name }}</div>
            <!-- 属性 -->
            <div class="props_box">
              <div class="props_item" :class="{ 'props_active': item.isCheck == true }" v-for="item in label.children"
                :key="item.name" @click="propsClick(item)">
                <span>{{ item.name }}</span>
                <img v-if="item.isCheck == true" src="@/assets/images/选中.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧属性设置 -->
        <div class="right_box">
          <!-- 积分奖励规则 -->
          <div class="right_rules">
            <div class="right_rules_title">订单屏蔽规则</div>
            <div class="right_rules_content">
              <!-- 列表 -->
              <div class="right_rules_item" v-for="item in selectList" :key="item.name">
                <!-- 规则名称 -->
                <div class="item_label"><span>*</span>{{ item.name }}</div>
                <span v-if="item.name != '当月首笔'" style="margin-left: 2px;">:</span>
                <!-- 规则设置 -->
                <!-- 下单/付款/确认收货时间 -->
                <div class="item_value" v-if="ruleType(item) == 1">
                  <time-pick
                    style="margin-left: 10px"
                    type="datetime"
                    :startTime.sync="item.start"
                    :endTime.sync="item.end"
                    @change="(time) => changeOrderDate(time,item)"
                  ></time-pick>
                </div>
                <!-- 订单金额 -->
                <div class="item_value" v-if="ruleType(item) == 2">
                  <el-input v-model="item.start" class="select_input" style="margin-left:10px"></el-input>
                  <div class="connecting_line">—</div>
                  <el-input v-model="item.end" class="select_input"></el-input>
                </div>
                <!-- 当月首笔只需选中即可 -->
                <div class="item_value" v-if="ruleType(item) == 3"></div>
                <!-- 卖家旗帜 -->
                <div class="item_value" v-if="ruleType(item) == 4">
                  <el-select v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption3" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-select v-model="item.checkBox" multiple collapse-tags class="item_select2">
                    <el-option v-for="options in selectOption7" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-tooltip effect="dark" placement="top-start">
                    <div slot="content">仅支持淘宝平台的卖家旗帜</div>
                    <img class="tips_img" src="@/assets/images/问号.png">
                  </el-tooltip>
                </div>
                <!-- 指定平台 -->
                <div class="item_value" v-if="ruleType(item) == 5">
                  <el-select v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption4" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-select v-model="item.checkBox" multiple collapse-tags class="item_select2">
                    <el-option v-for="options in selectOption8" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                </div>
                <!-- 指定商品/购买过商品 -->
                <div class="item_value" v-if="ruleType(item) == 6">
                  <el-select v-if="item.name == '购买过商品'" v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption3" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-select v-else v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption5" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <span v-if="item.name == '指定商品'" class="select_btn" @click="selectGoods(1)">已选择<span
                      style="color: #ff8d59;">{{ item.items.length }}</span>个商品</span>
                  <span v-else class="select_btn" @click="selectGoods(2)">已选择<span style="color: #ff8d59;">{{
                    item.items.length }}</span>个商品</span>
                </div>
                <!--  指定店铺 -->
                <div class="item_value" v-if="ruleType(item) == 11">
                  <el-select v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption5" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-select v-model="item.checkBox" multiple collapse-tags class="item_select2">
                    <el-option v-for="options in selectOption13" :key="options.channelSellerManageId"
                      :label="options.shopTitle" :value="options.channelSellerManageId"></el-option>
                  </el-select>
                </div>
                <!-- 周会员日&月会员日 -->
                <div class="item_value" v-if="ruleType(item) == 7">
                  <el-select v-if="item.name == '周会员日'" v-model="item.checkBox" multiple collapse-tags
                    class="item_select2">
                    <el-option v-for="options in selectOption9" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-select v-else v-model="item.checkBox" multiple collapse-tags class="item_select2">
                    <el-option v-for="options in selectOption10" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                </div>
                <!-- 会员等级 -->
                <div class="item_value" v-if="ruleType(item) == 8">
                  <el-select v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption3" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                  <el-select v-model="item.checkBox" multiple collapse-tags class="item_select2">
                    <el-option v-for="options in selectOption11" :key="options.gradeCode" :label="options.gradeName"
                      :value="options.scoresMemberGradeId"></el-option>
                  </el-select>
                </div>
                <!-- 会员生日 -->
                <div class="item_value" v-if="ruleType(item) == 9">
                  <el-select v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption6" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                </div>
                <!-- 是否预售 -->
                <div class="item_value" v-if="ruleType(item) == 10">
                  <el-select v-model="item.enumValue" class="item_select">
                    <el-option v-for="options in selectOption12" :key="options.name" :label="options.label"
                      :value="options.value"></el-option>
                  </el-select>
                </div>
                <!-- 操作 -->
                <div class="item_operate">
                  <img @click="propsDelete(item)" src="@/assets/images/删除2.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </y-dialog>
    <!-- 选择店铺弹窗 -->
    <chooseShop v-if="chooseShopShow" :visible="chooseShopShow" :selected.sync="selectShopList"
      @close="chooseShopShow = false"></chooseShop>
    <!-- 选择商品组件 -->
    <select-goods v-if="goodsState" @transferName="goodsPopupBtn" :postForm="goodsPostForm"
      :scoresCardId="$store.state.MemberSystemInfo.scoresCardId"></select-goods>
  </div>
</template>

<script>
// import dateTime from "./form/date-range";
import timePick from "./newComponents/Form/timePick.vue"
import chooseShop from "@/components/chooseShop.vue"
import selectGoods from "@/components/select-goods.vue";
import { isScoresBindList, getDetailById, rewardRuleDetail, rewardRuleSave } from "@/api/integralCenter/newMemberSystem"
export default {
  components: {
    // dateTime,
    chooseShop,
    selectGoods,
    timePick
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      ruleName: "",
      selectList: [], // 已选择选项
      // 左侧属性标签
      options: [
        {
          name: "屏蔽条件",
          children: [
            { name: "下单时间", labelName: "order_time", isCheck: false, start: "", end: "" },
            { name: "付款时间", labelName: "payment_time", isCheck: false, start: "", end: "" },
            { name: "确认收货时间", labelName: "confirm_receipt_time", isCheck: false, start: "", end: "" },
            { name: "订单实付金额（不含邮费）", labelName: "order_amount_no_postage", isCheck: false, start: "", end: "" },
            { name: "订单实付金额（包含邮费）", labelName: "order_amount_have_postage", isCheck: false, start: "", end: "" },
            { name: "会员等级", labelName: "member_grade", isCheck: false, enumValue: 1, checkBox: [] },
            { name: "卖家旗帜", labelName: "seller_flag", isCheck: false, enumValue: 1, checkBox: [] },
            { name: "指定平台", labelName: "platform", isCheck: false, enumValue: 1, checkBox: [] },
            { name: "指定店铺", labelName: "shop", isCheck: false, enumValue: 1, checkBox: [] },
            { name: "指定商品", labelName: "item", isCheck: false, enumValue: 1, items: [] },
            { name: "是否预售", labelName: "is_pre_sale", isCheck: false, enumValue: 1 },
            { name: "购买过商品", labelName: "history_pay_item", isCheck: false, enumValue: 1, items: [] },
            { name: "当月首笔", labelName: "month_first_order", isCheck: false },
          ]
        }
      ],
      optionsDefault: [], // 初始数据
      // 右侧属性选项
      selectOption3: [
        { label: "包含任一", value: 1 },
        { label: "不包含", value: 0 },
      ],
      selectOption4: [
        { label: "属于", value: 1 },
        { label: "不属于", value: 0 },
      ],
      selectOption5: [
        { label: "包含", value: 1 },
        { label: "不包含", value: 0 },
      ],
      selectOption6: [
        { label: "生日当天", value: 1 },
        { label: "生日当周", value: 2 },
        { label: "生日当月", value: 3 },
      ],
      selectOption7: [
        { label: "红旗", value: 0 },
        { label: "黄旗", value: 1 },
        { label: "绿旗", value: 2 },
        { label: "蓝旗", value: 3 },
        { label: "紫旗", value: 4 },
        { label: "灰旗", value: 5 },
      ],
      selectOption8: [
        { label: "淘宝", value: 1 },
        { label: "京东", value: 2 },
        { label: "抖音", value: 5 },
      ],
      selectOption9: [
        { label: "周一", value: 1 },
        { label: "周二", value: 2 },
        { label: "周三", value: 3 },
        { label: "周四", value: 4 },
        { label: "周五", value: 5 },
        { label: "周六", value: 6 },
        { label: "周日", value: 7 },
      ],
      selectOption10: [], // 月会员日
      selectOption11: [], // 会员等级
      selectOption12: [
        { label: "预售", value: 1 },
        { label: "非预售", value: 0 },
      ],
      selectOption13: [], // 选择店铺
      MemberSystemInfo: {},

      chooseShopShow: false, // 选择店铺弹窗
      selectShopList: [], // 已选店铺列表
      goodsState: false, // 选择商品弹窗
      goodsPostForm: [], // 已选商品数据---弹窗用
      selectGoodsList: [], // 已选商品列表--指定商品
      selectGoodsList2: [], // 已选商品列表--购买过商品
      selectGoodsType: 1, // 用于储存当前打开的弹窗类型，因公用一个组件，以此区分
    }
  },
  created() {
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo
    // 弹窗加载时保存初始数据
    this.optionsDefault = JSON.parse(JSON.stringify(this.options))
    for (let i = 1; i <= 31; i++) {
      this.selectOption10.push({
        label: i,
        value: i
      })
    }
    this.getScoresBindList()
    this.getLevel()
    if (this.rowData.scoresRewardRuleId) this.getRuleDetail();
  },
  methods: {
    changeOrderDate(time,item) {
      item.start = time.startTime
      item.end = time.endTime
    },
    // 获取奖励积分规则详情
    getRuleDetail() {
      let _this = this
      rewardRuleDetail({ ruleId: this.rowData.scoresRewardRuleId }).then(res => {
        let data = res.data;
        _this.ruleName = data.ruleName
        // 属性选中回显
        data.conditionList.forEach(item => {
          console.log(item);
          this.options.forEach(item2 => {
            item2.children.forEach(child => {
              if (child.labelName == item.type) {
                // 左侧属性选中
                child.isCheck = true;
                // 右侧展示规则
                this.selectList.push(JSON.parse(JSON.stringify(child)))
              }
            })
          })
        })
        // 对应项赋值操作
        data.conditionList.forEach(item => {
          this.selectList.forEach(item2 => {
            if (item.type == item2.labelName) {
              let childType = this.ruleType(item2)
              if ([1, 2].includes(childType)) {// 时间选择器&&订单金额
                item2.start = item.start
                item2.end = item.end
              }
              if ([4, 5, 8, 11].includes(childType)) { // 多选框
                item2.checkBox = item.checkBox.split(',').map(item => Number(item))
              }
              if ([4, 5, 6, 8, 10, 11].includes(childType)) { // 枚举值
                item2.enumValue = item.enumValue
              }
              // 商品列表回显
              if (childType == 6) {
                item2.items = item.items.map(ms => {
                  return {
                    numIid: ms.itemId,
                    picUrl: ms.itemImage,
                    itemTitle: ms.itemName,
                    price: ms.itemPrice,
                    channelSellerManageId: ms.scoresRewardIncludeItemId,
                    platform: ms.platform,
                  }
                })
                console.log(item2);
              }
            }
          })
        })
      })
    },
    // 保存
    handleDialogConfirm() {
      let _this = this
      if (!this.ruleName) return this.$message.warning("请填写规则名称")
      if (!this.selectList.length) return this.$message.warning("请选择屏蔽规则")
      let flag = false
      this.selectList.some(item => {
        console.log(item);
        let type = this.ruleType(item)
        if ((type == 1 || type == 2) && (!item.start && !item.end)) {
          flag = true
          return this.$message.warning("请输入" + item.name)
        }
        if ((type == 4 || type == 5 || type == 8 || type == 11) && !item.checkBox.length) {
          flag = true
          return this.$message.warning("请选择" + item.name)
        }
        if (type == 6 && !item.items.length) {
          flag = true
          return this.$message.warning("请选择" + item.name)
        }
      })
      if (flag) return
      let obj = {
        ruleName: this.ruleName,
        ruleType: 2,
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        conditionList: [] // 规则列表
      }
      let list = []
      this.selectList.forEach(item => {
        let label = { ...item, type: item.labelName }
        // 商品传输处理
        if (item.name.includes("商品")) {
          console.log(label.items);
          let items = []
          item.items.forEach(itemChild => {
            items.push({
              itemId: itemChild.numIid,
              itemImage: itemChild.picUrl,
              itemName: itemChild.itemTitle,
              itemPrice: itemChild.price,
              scoresCardId: this.MemberSystemInfo.scoresCardId,
              scoresRewardIncludeItemId: itemChild.channelSellerManageId,
              platform: itemChild.platform,
            })
          })
          label.items = items
        }
        delete label.name
        delete label.labelName
        delete label.isCheck
        if (label.checkBox) label.checkBox = label.checkBox.join()
        list.push(label)
      })
      obj.conditionList = list
      // 编辑保存
      if (this.rowData.scoresRewardRuleId) {
        obj.scoresRewardRuleId = this.rowData.scoresRewardRuleId
      }
      console.log('处理数据:', obj);
      rewardRuleSave(obj).then(res => {
        _this.$message.success("创建成功")
        setTimeout(() => {
          _this.$emit("close", true);
        }, 100)
      })
    },
    // 获取会员等级
    getLevel() {
      getDetailById({ cardId: this.MemberSystemInfo.scoresCardId }).then(res => {
        this.selectOption11 = res.data.gradeList
      })
    },
    // 获取店铺列表
    getScoresBindList() {
      let _param = {
        scoresCardId: this.MemberSystemInfo.scoresCardId,
        pageNum: 1,
        pageSize: 99,
      }
      isScoresBindList(_param).then((res) => {
        if (res.code == 200) {
          this.selectOption13 = res.data.dataList
        }
      });
    },
    // 选择店铺弹窗
    selectShop() {
      this.chooseShopShow = true
    },
    // 选择商品弹窗
    selectGoods(val) {
      // val：1指定商品 2购买过商品
      // 记录当前打开的是哪种条件的弹窗
      this.selectGoodsType = val
      console.log(this.selectGoodsList, this.selectGoodsList2);
      // 修改弹窗回显
      if (val == 1) {
        this.goodsPostForm = this.selectList.filter(item => item.name == "指定商品")[0].items
        this.goodsState = true
      } else {
        this.goodsPostForm = this.selectList.filter(item => item.name == "购买过商品")[0].items
        this.goodsState = true
      }
    },
    goodsPopupBtn(event, state) { // state：0取消 1确定
      this.goodsState = false;
      console.log("选择完返回的数据event", event, state);
      if (state == 1) {
        if (state == 1) {
          this.selectList.forEach(item => {
            if (item.name == "指定商品" && this.selectGoodsType == 1) item.items = event
            if (item.name == "购买过商品" && this.selectGoodsType == 2) item.items = event
          })
        }
      }
    },
    // 点击左侧标签
    propsClick(value) {
      value.isCheck = !value.isCheck
      console.log(this.options);
      // 选中-添加
      if (value.isCheck) {
        this.selectList.unshift(JSON.parse(JSON.stringify(value)))
      } else { // 移除
        this.selectList.forEach((item, index) => {
          if (item.name == value.name) {
            this.selectList.splice(index, 1)
            return
          }
        })
      }
      console.log('选中项列表======>', this.selectList);
    },
    // 删除当前规则
    propsDelete(value) {
      // 从已选列表中删除
      this.selectList.forEach((item, index) => {
        if (item.name == value.name) {
          this.selectList.splice(index, 1)
          return
        }
      })
      console.log(this.options);
      // 重置当前属性
      this.options.forEach(item => {
        item.children.forEach(item2 => {
          if (item2.name == value.name) {
            item2.isCheck = false
          }
        })
      })
      console.log('当前项', value);
    },
    // 判断当前规则类型
    ruleType(val) {
      if (["下单时间", "付款时间", "确认收货时间"].includes(val.name)) return 1;
      if (["订单实付金额（不含邮费）", "订单实付金额（包含邮费）"].includes(val.name)) return 2;
      if (["当月首笔"].includes(val.name)) return 3;
      if (["卖家旗帜"].includes(val.name)) return 4;
      if (["指定平台"].includes(val.name)) return 5;
      if (["指定商品", "购买过商品"].includes(val.name)) return 6;
      if (["会员等级"].includes(val.name)) return 8;
      if (["是否预售"].includes(val.name)) return 10;
      if (["指定店铺"].includes(val.name)) return 11;
    },

    // 关闭弹窗
    handleDialogClose() {
      // 清空选中项,将属性初始化
      this.selectList = []
      this.options = JSON.parse(JSON.stringify(this.optionsDefault))
      this.$emit("close", false);
    },
    // 折叠面板方法 暂无作用
    collapseChange() { },
  },
}
</script>

<style lang="scss" scoped>
.main {
  display: flex;

  .left_box {
    width: 400px;
    max-height: 500px;
    // overflow-y: scroll;

    .label_box {
      border: 1px solid #F3F4F7;
      border-radius: 6px;

      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }

    .label_title {
      font-weight: bold;
      font-size: 14px;
      width: 100%;
      color: #333333;
      background: #F4F4F4;
      padding: 10px 10px;
      box-sizing: border-box;
    }

    .props_box {
      // display: flex;
      // flex-wrap: wrap;
      padding: 5px 0;
      width: 100%;
      height: 400px;
      overflow-y: scroll;

      .props_item {
        position: relative;
        display: inline-block;
        font-size: 12px;
        background: #FFFFFF;
        color: #333333;
        padding: 6px 20px;
        margin: 4px 6px;
        cursor: pointer;
        box-sizing: border-box;
        border-radius: 6px;
        border: 1px solid #CCCCCC;

        img {
          position: absolute;
          width: 15px;
          height: 13px;
          right: -1px;
          bottom: -1px;
        }

      }

      .props_active {
        border: 1px solid $theme-color;
      }
    }
  }

  .right_box {
    flex: 1;
    margin-left: 20px;
    // height: 300px;


    .right_rules {
      margin-bottom: 20px;
      border-radius: 6px;
      border: 1px solid #F3F4F7;

      .right_rules_title {
        box-sizing: border-box;
        font-weight: bold;
        font-size: 14px;
        background: #F4F4F4;
        padding: 10px 11px;
        color: #333333;
      }

      .right_rules_content {
        height: 410px;
        overflow-y: scroll;

        .right_rules_item {
          display: flex;
          align-items: center;
          height: 60px;
          padding-left: 10px;
          border-bottom: 1px solid #EFEFEF;

          &:nth-child(even) {
            background: #F9FCFF;
          }

          .item_label {
            width: 100px;
            text-align: right;
            font-size: 12px;

            span {
              color: red;
              margin-right: 5px;
            }
          }

          .item_value {
            width: 470px;

            .item_select {
              width: 140px;
              margin: 0 10px;
            }

            .item_select2 {
              width: 240px;
              margin: 0 10px;
            }

            .select_input {
              width: 125px;
            }

            .select_btn {
              color: $theme-color;
              // margin: 0 10px;
              margin-left: 12px;
              cursor: pointer;
              font-size:12px;

              span {
                margin: 0 5px;
              }
            }

            .connecting_line {
              display: inline-block;
              margin: 0 10px;
            }

            .tips_img {
              width: 18px;
              height: 18px;
              position: relative;
              top: 4px;
            }
          }

          .item_operate {
            flex: 1;
            text-align: center;

            img {
              cursor: pointer;
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    }
  }

  .right_limit {
    border: 1px solid #F3F4F7;
    border-radius: 6px;

    .right_limit_title {
      box-sizing: border-box;
      font-weight: bold;
      font-size: 14px;
      background: #F4F4F4;
      padding: 10px 11px;
      color: #333333;
    }

    .right_limit_content {
      height: 112px;
      padding: 15px 0 0 20px;

      >div {
        margin-bottom: 24px;
      }

      img {
        width: 14px;
        height: 14px;
        position: relative;
        right: -2px;
        top: 2px;
      }
    }
  }
}
</style>